export default __webpack_public_path__ + "static/media/home-branding-agency-img-03.23aa12d9.jpg";